/********************************************************************
 * Project: WDCK（2021）
 * Class: AlphanumbericSymbolDirective
 * ----------------------------------------
 * <summary>
 * AlphanumbericSymbolDirective
 * </summary>
 * <history>
 *      ThaiTV     2021/10/05      Create
 * </history>
 ********************************************************************/
import { Directive, ElementRef, HostListener } from '@angular/core';
import { Utility } from '../utility/utility';

@Directive({
    selector: '[alphanumberic-symbol]',
})
export class AlphanumbericSymbolDirective {
    regHaftWidth = /[^0-9a-zA-Z\ \!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\>\=\?\@\[\]\{\}\\\\\^\_\`\~]/g;

    constructor(
        private el: ElementRef,
        public utility: Utility,
    ) {
    }
    @HostListener('paste', ['$event']) blockPaste(e) {
        const clipboardData = e.clipboardData;
        if (clipboardData) {
            const pastedText = clipboardData.getData('text/plain');
            const pastedTextCoppy = pastedText.replace(this.regHaftWidth, '');
            if (pastedTextCoppy !== pastedText) {
                e.preventDefault();
            }
        }
    }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this.el.nativeElement.value;
        this.el.nativeElement.value = initalValue.replace(this.regHaftWidth, '');
        if (initalValue !== this.el.nativeElement.value) {
            event.stopPropagation();
        }
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event) {
        if (this.el.nativeElement.value.trim() === '' && event.which === 32) {
            event.preventDefault();
        }
    }
}
